import { sharedColors } from "ui/theme/colors"
import { extractProperty } from "utils"

export type AccentPalette = {
  /* Base accent — plain accent text (statistics numbers) */
  base: string
  /*
   * Resting fill of a selected tab / primary surface. Always a gradient
   * string (solid colors are expressed as single-color gradients) so it
   * can double as the border-box layer of outlined elements, whose
   * border per the Figma spec uses the same ramp as the primary fill.
   */
  fill: string
  hover: string
  active: string
  /* Text color on top of the accent fills */
  contrastText: string
}

/*
 * Accent treatments from the Figma "ds egged plus" Main CTA spec
 * (EGDW-440/441/442), keyed by the Umbraco color-picker hex that editors
 * set per block and per culture. Green (008761) is intentionally absent —
 * it keeps the default design-system styling.
 */
const accentPalettes: Record<string, AccentPalette> = {
  f86f3e: {
    base: "#f86f3e",
    fill: "linear-gradient(to right, #ffb06d, #f86f3e)",
    hover: "#f86f3e",
    active: "#eb6232",
    contrastText: sharedColors.black,
  },
  "303eaf": {
    base: "#303eaf",
    fill: "linear-gradient(#303eaf, #303eaf)",
    hover: "#232e83",
    active: "#1c2672",
    contrastText: sharedColors.white,
  },
}

export function getBlockAccentPalette(data: any): AccentPalette | undefined {
  const color = extractProperty(data, "colorPicker")?.color
  return color ? accentPalettes[String(color).toLowerCase()] : undefined
}
